import React from "react";
import PropTypes from "prop-types";
import {
    monthNameShortString,
    onlyDateString,
    onlyYearString
} from "../../services/date/formatters";

import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const StackedDate = props => {
    const {date, small} = props;
    const day = onlyDateString(date);
    const month = monthNameShortString(date);
    const year = onlyYearString(date)

    return (
        <Stack alignItems="center" flexGrow={1}>
            <Typography fontWeight='light' fontSize={12}>
                {year}
            </Typography>
            <Typography fontWeight='medium' fontSize={small ? 20 : 28}>
                {day}
            </Typography>
            <Typography fontWeight='medium' fontSize={small ? 12 : 18} sx={{textTransform: 'uppercase'}}>
                {month}
            </Typography>
        </Stack>
    )
}

const StackedDateRange = props => {
    const {arrivalDate, departureDate, sx, small} = props;

    return (
        <Stack direction="row" spacing={1} sx={{...sx}}>
            <StackedDate date={arrivalDate} small={small}/>
            <Divider orientation="vertical" flexItem/>
            <StackedDate date={departureDate} small={small}/>
        </Stack>
    )
}

StackedDateRange.propTypes = {
    arrivalDate: PropTypes.instanceOf(Date).isRequired,
    departureDate: PropTypes.instanceOf(Date).isRequired,
    sx: PropTypes.object,
    small: PropTypes.bool,
};

export default StackedDateRange;